import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	lastUpdatedTimeText: {
		id: 'servicedesk-settings-virtual-agent-create-intent-templates-sidebar.content.last-updated-timestamp.last-updated-time-text',
		defaultMessage: 'Updated {timestampMessage}',
		description:
			'Text on the intent template sidebar indicating when discovered templates were last generated',
	},
});
